/**
 * Make sure the breakpoints are based on the container width, and not the window width
 */
export const getResponsiveBreakpointsSlider = (totalScreenWidth, containerWidth) => {
    const widthInclMargin = (width) => width + (totalScreenWidth - containerWidth);
    const responsive = {
        bigger: {
            breakpoint: { max: widthInclMargin(40000), min: widthInclMargin(1120) },
            items: 6,
        },
        desktop: {
            breakpoint: { max: widthInclMargin(1120), min: widthInclMargin(900) },
            items: 5,
        },
        tablet: {
            breakpoint: { max: widthInclMargin(900), min: widthInclMargin(700) },
            items: 4,
        },
        smallTablet: {
            breakpoint: { max: widthInclMargin(700), min: widthInclMargin(600) },
            items: 3,
        },
        mobile: {
            breakpoint: { max: widthInclMargin(600), min: 0 },
            items: 2.5,
        },
    };
    return responsive;
};
